import styled from '@emotion/styled'
import {theme} from '../../theme'

// ─── Overlay ──────────────────────────────────────────────────────────────────

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${theme.zIndex.overlay};
  transition: opacity ${theme.transitions.slow};
  opacity: ${({isOpen}) => (isOpen ? 1 : 0)};
  pointer-events: ${({isOpen}) => (isOpen ? 'all' : 'none')};
`

// ─── Panel ────────────────────────────────────────────────────────────────────
// Direction-specific placement and border are handled via props.

export const Panel = styled.div`
  position: fixed;
  background: ${theme.colors.bg.primary};
  z-index: ${theme.zIndex.modal};
  display: flex;
  flex-direction: column;
  transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1),
    box-shadow ${theme.transitions.slow};

  /* ── Size via CSS custom property set inline ── */
  --drawer-size: 320px;

  /* ── Placement ── */
  ${({direction}) => {
    switch (direction) {
      case 'right':
        return `
          top: 0; right: 0; bottom: 0;
          width: var(--drawer-size);
          height: 100%;
          border-left: 1px solid ${theme.colors.border.default};
        `
      case 'top':
        return `
          top: 0; left: 0; right: 0;
          width: 100%;
          height: var(--drawer-size);
          border-bottom: 1px solid ${theme.colors.border.default};
        `
      case 'bottom':
        return `
          bottom: 0; left: 0; right: 0;
          width: 100%;
          height: var(--drawer-size);
          border-top: 1px solid ${theme.colors.border.default};
        `
      case 'left':
      default:
        return `
          top: 0; left: 0; bottom: 0;
          width: var(--drawer-size);
          height: 100%;
          border-right: 1px solid ${theme.colors.border.default};
        `
    }
  }}

  /* ── Open / closed transform ── */
  ${({direction, isOpen}) => {
    const transforms = {
      left: ['translateX(-100%)', 'translateX(0)'],
      right: ['translateX(100%)', 'translateX(0)'],
      top: ['translateY(-100%)', 'translateY(0)'],
      bottom: ['translateY(100%)', 'translateY(0)'],
    }
    const [closed, open] = transforms[direction] ?? transforms.left
    return `transform: ${isOpen ? open : closed};`
  }}

  /* ── Shadow only when open ── */
  box-shadow: ${({isOpen}) => (isOpen ? theme.shadows.lg : 'none')};
`
